/**
 * Permet de joindre des classes dynamique pour en créer une chaîne de chars
 * @param  {[type]} classes [description]
 * @return {[type]}         [description]
 */
export function classesNames(classes){
  return Object.keys(classes).filter( c => classes[c]).join(' ')
}
